/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCollapsible = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 16v2H2v-2zm4-10v6H10V6zm-14.707.293 1.414 1.414L5 11.414 1.293 7.707l1.414-1.414L5 8.585zM19.999 8h-8v2h8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCollapsible as Collapsible };
